import { render, staticRenderFns } from "./Podcast2023.vue?vue&type=template&id=612e6655&scoped=true&"
import script from "./Podcast2023.vue?vue&type=script&lang=js&"
export * from "./Podcast2023.vue?vue&type=script&lang=js&"
import style0 from "./Podcast2023.vue?vue&type=style&index=0&id=612e6655&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e6655",
  null
  
)

export default component.exports